<template>
  <div class="policy-details">
    <div class="policy-title">
      <!--<span>首页 > 用户协议</span>-->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户协议</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="policy-content">
      <div class="main-content">
        <div class="title-content">
          <div class="details-title">
            <h2>峰学未来用户协议</h2>
          </div>
        </div>
        <div class="details-content">
          <p>
            欢迎申请使用苏州峰学未来教育科技有限公司（以下简称“峰学未来”）提供的软件，在使用峰学未来的服务之前，您应当阅读并遵守本协议及《隐私保护政策》。
            请您务必审慎阅读、充分理解各条款的内容。未成年人应当在法定监护人的陪同下阅读。
          </p>
          <p>峰学未来提示您：</p>
          <strong>（1）当您按照注册页面提示填写信息、阅读并同意本协议由且完成全部注册程序后，或您按提示阅读并同意本协议后，
            或您以其他峰学未来学习平台允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。
            您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议内容，主张本协议无效，或要求撤销本协议。</strong>
          <strong>（2）本协议可由峰学未来随时更新，更新后的协议条款一旦公布即代替旧版，恕不再另行通知，
            用户可在本软件查阅最新版协议条款。在峰学未来修改本协议条款后，如果用户不接受修改后的条款，
            请立即停止使用峰学未来提供的服务，用户继续使用峰学未来的服务将被视为已接受了修改后的协议。</strong>
          <strong>（3）本协议内容同时包括峰学未来可能不断发布的关于本服务的相关协议、业务规则等内容。
            上述内容一经正式发布，即为本协议不可分割的组成部分。</strong>
          <h3 style="margin-top: 10px;">一、 缔约主体</h3>
          <p>本协议通过使用峰学未来学习平台产品移动客户端以及其他方式使用峰学未来学习平台服务的用户（以下简称“用户”或“您”），与峰学未来共同缔结。</p>
          <h3>二、 协议内容</h3>
          <p>本软件所包含的所有文字、图标、用户界面、可视界面、图片、商标、标识、声音、音乐、美术作品及计算机编码（合称为“内容”），
            包括但不限于该等内容的设计、结构、选择、协调、表达、界面外观及排序等，均属峰学未来或其他权利人所有，且受著作权法、专利法、
            商标法以及各类其他知识产权法的保护。除本用户协议明确规定外，未经峰学未来及/或其他权利人事先书面明确同意，
            您不得为出版或发行或为任何其他商业目的以任何方式将本软件的任何部分及任何内容复制、再制、重印、上传、发布、公开展示、编码、翻译、
            传输或散步至任何其他终端、网站或其他媒介。</p>
          <h3>三、 本软件的获取、安装、卸载及更新</h3>
          <p>1、您可以从峰学未来授权的第三方获取本软件，如果您从未经峰学未来授权的第三方获取本软件或与本软件名称相同的安装程序，
            峰学未来无法保证该软件的正常使用，并对因此给您造成的损失不予负责。</p>
          <p>2、峰学未来可能为不同的终端开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。
            下载安装程序后，您需要按照该程序提示的步骤正确安装。为提供更加优质、安全的服务，如果您不再需要使用本软件或需要安装新版软件，可以自行卸载。</p>
          <p>3、为了改善用户体验、完善服务内容，峰学未来将不断努力开发新的服务，并为您不时提供软件更新。为了保证本软件及服务的安全性和功能的一致性，
            峰学未来有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。
            本软件新版发布后，旧版本的软件可能无法使用。峰学未来不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</p>
          <h3>四、 注册及账号管理</h3>
          <strong>1、您注册成为本软件用户即可获得一个ID（以下或称“用户”），您应当妥善保管好自己的账号、密码，对其用户账号进行的所有活动和事件负相应责任，
            并不得转让、出借、出租、出售或分享给予他人使用，否则峰学未来有权根据实际情况暂时封停或永久查封此账号。
            如用户发现其账号遭他人非法使用，应当立即通知峰学未来，否则未经授权的使用行为均视为用户本人的行为。
            因黑客行为或用户的保管疏忽导致账号、密码遭到他人非法使用，峰学未来不承担任何责任。</strong>
          <p>2、本条及本协议其他条款未明示授权的其他一切权利仍由峰学未来保留，您在行使这些权利时必须另外取得峰学未来的书面许可。
            峰学未来如果未行使前述任何权利，并不构成对该权利的放弃。</p>
          <p>3、您应遵守本协议的各项条款，正确、适当地使用本服务，如您违反本协议中的任何条款，峰学未来有权依据协议中断或终止对违约用户账号提供服务。</p>
          <p>4、如果峰学未来收到他人举报或投诉您违反本协议约定的，峰学未来有权不经通知随时对相关内容进行删除、屏蔽，
            并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并有权公告处理结果</p>
          <h3>五、 用户个人信息保护</h3>
          <p>保护用户个人信息是峰学未来的一项基本原则，峰学未来将会采取合理的措施保护您的个人信息。
            除法律法规规定的情形外，未经用户许可峰学未来不会向第三方公开、透露用户个人信息。
            峰学未来将按照国家法律法规保障您的个人信息安全。具体内容请查看《隐私权保护政策》。</p>
          <h3>六、 按现状提供服务</h3>
          <strong>您理解并同意，峰学未来的服务是按照现有技术和条件所能达到的现状提供的。峰学未来会尽最大努力向您提供服务，确保服务的连贯性和安全性；
            但峰学未来不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、
            系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失及其他的损失和风险。</strong>
          <h3 style="margin-top: 10px;">七、 服务使用规范</h3>
          <p>1、您在使用本软件时，必须遵守中华人民共和国相关法律法规及相关国际公约的规定，用户同意将不会利用本服务进行任何违法或不正当的活动，
            包括但不限于下列行为：</p>
          <p>（1）违反中华人民共和国宪法确定的基本原则的；</p>
          <p>（2）危害国家安全、泄露国际秘密，颠覆国家政权，破坏国家统一；</p>
          <p>（3）损害国家荣誉和利益的；</p>
          <p>（4）煽动民族仇恨、民族歧视、破坏民族团结的；</p>
          <p>（5）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>（6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>（7）含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其他道德上令人反感的内容；</p>
          <p>（8）以非法民间组织名义活动的；</p>
          <p>（9）不符合应当遵守法律法规、社会主义制度、国家利益、公民合法利益、公众秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>
          <p>（10）含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其他内容的。</p>
          <p>2、用户不得利用峰学未来提供的服务制作、上载、复制、发布、传播如下干扰本软件正常运营，以及侵权其他用户或第三方合法权益的内容：</p>
          <p>（1）含有任何性或性暗示的；</p>
          <p>（2）含有辱骂、恐吓、威胁内容的；</p>
          <p>（3）含有骚扰、垃圾广告、恶意信息、诱骗信息的；</p>
          <p>（4）涉及他人隐私、个人信息或资料的；</p>
          <p>（5）侵害他人一般人格权、名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
          <p>（6）含有其他干扰本软件正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
          <p>3、用户不得为任何非法目的而使用软件，不利用本软件从事以下活动：</p>
          <p>（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
          <p>（2）未经允许，对计算机信息网络功能进行删除、修改或增加；</p>
          <p>（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
          <p>（4）故意制作、传播计算机病毒等破坏性程序的；</p>
          <p>（5）其他危害计算机信息网络安全的行为。</p>
          <p>4、用户不得利用本软件从事下列行为：</p>
          <p>（1）提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义；</p>
          <p>（2）强制、诱导其他用户关注、点击链接页面或分享信息；</p>
          <p>（3）虚构事实、隐瞒真相以误导、欺骗他人的；</p>
          <p>（4）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</p>
          <p>（5）未经峰学未来书面许可利用峰学未来账号和任何功能进行推广或互相推广的；</p>
          <p>（6）利用技术手段批量建立虚假账号；</p>
          <p>（7）制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</p>
          <p>（8）其他违反法律法规规定、侵犯其他用户合法权益、干扰本软件正常运营的行为。</p>
          <p>5、凡用户昵称中出现如下信息者（包括但不限于），峰学未来有权进行屏蔽、锁定、甚至注销：</p>
          <p>（1）使用严重违反国家法律法规及风序良俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；</p>
          <p>（2）使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；</p>
          <p>（3）使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；</p>
          <p>（4）含性别歧视、种族歧视、地域歧视等信息的昵称；</p>
          <p>（5）含自辱、猥亵或者对他人进行侮辱、挑衅、漫骂、人身攻击等不文明、不健康信息的昵称；</p>
          <p>（6）含易产生歧义、引起他人误解的信息的昵称；</p>
          <p>（7）未获得“峰学未来”正式许可而使用带“峰学未来”相关名称的昵称；</p>
          <p>（8）“峰学未来”老师、助教及社区管理人员的昵称近似或雷同，并可能引起混淆或纠纷的；带有明显广告性质的昵称；</p>
          <p>（9）带有其他法律法规以及峰学未来禁止规则中所包含信息的昵称。</p>
          <strong>6、用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，
            包括但不限于为解决纠纷因此产生的律师费、诉讼费，您同意赔偿峰学未来与合作公司、关联公司上述费用，并使之免受损害。
            对此，峰学未来有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、
            限制使用、回收ID、追究法律责任等措施。</strong>
          <strong>7、对恶意注册ID或利用ID进行违法活动，捣乱、骚扰、欺骗其他用户以及其他违反本协议的行为，
            峰学未来以及其他违反本协议的行为，峰学未来有权回收其账号。同时，峰学未来会视司法部门的要求协助调查。</strong>
          <strong>8、用户须对自己在使用本软件过程中的行为承担法律责任，
            自己对传送信息的真实性、合法性、无害性、准确性、有效性等全权负责。
            用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在本软件首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，
            峰学未来会对用户进行追偿。</strong>
          <h3 style="margin-top: 10px;">八、 知识产权</h3>
          <p>本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及本软件包含的任何文字、图表、音频、视频或软件
            （包括但不限于题库解析、视频、文字、软件、声音、图片、图表、数据、程序、代码、文档、界面设计）
            等信息或材料均受著作权法、商标法、专利法或其他法律法规、国际条约的保护。
            未经授权，用户不得对签署峰学未来享有知识产权的信息进行修改、拷贝、散布、传送、展示、执行、复制、发行、制作衍生著作权、转移或销售。
            如您未遵守本条款，视为对峰学未来的侵权，峰学未来有权且无需通知即可立即终止为您提供服务，解除双方间的服务协议和法律关系，
            且无需退还您所支付的费用，如费用不足以弥补峰学未来的损失的，峰学未来还可通过其他法律渠道向您追索，
            同时您必须销毁任何已获得的上述信息。</p>
          <h3>九、 争议解决</h3>
          <p>本用户协议及您与峰学未来的关系适用于中华人民共和国大陆地区法律。您和峰学未来同意服从峰学未来所在地法院的司法管辖。</p>
          <h3>十、 不可抗力</h3>
          <p>1、用户理解并同意，在使用本服务过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。
            不可抗力指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，
            包括但不限于自然灾害如洪水、地震、瘟疫、风暴等，以及社会事件如战争、动乱、政府行为等。出现上述情况时，
            峰学未来将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失峰学未来在法律允许范围内免责。</p>
          <strong>2、峰学未来对以下情形导致的服务中断或受阻不承担责任：</strong>
          <p style="margin-bottom: 0;"><strong>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</strong></p>
          <strong>（2）用户或峰学未来的电脑软件、系统、硬件和通信线路出故障；</strong>
          <strong>（3）用户操作不当或用户将密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，或其他非因峰学未来原因导致的个人信息的泄露；</strong>
          <strong>（4）用户通过非峰学未来授权的方式使用本服务的；</strong>
          <p style="margin-bottom: 0;"><strong>（5）其他峰学未来无法控制或合理预见的情形。</strong></p>
          <strong>3、峰学未来保留在任何时候不经通知进行以下行为的权利：</strong>
          <p style="margin-bottom: 0;"><strong>（1）给予任何原因修改、终止或中止本软件或其他任何部分的运行或访问；</strong></p>
          <strong>（2）修改或变更本软件或其他任何部分及适用政策或条款；</strong>
          <strong>（3）在进行任何定期或非定期维护、错误纠正或其他变更所需要时，中断本软件或其任何部分的运行。</strong>
          <h3 style="margin-top: 10px;">十一、 联系我们</h3>
          <p>您可以通过以下方式与我们联系：</p>
          <p>1、您可以寄信到如下地址：</p>
          <p>公司名称：苏州峰学未来教育科技有限公司</p>
          <p>地址：江苏省苏州市工业园区星湖街328号创意产业园6幢403</p>
          <p>2、您可以通过峰学未来网站/APP上提供的在线联系客服系统与我们联系；</p>
          <div class="sig con-part">
            <p>苏州峰学未来科技有限公司</p>
            <p>2023年1月31日</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<someComponent></someComponent>-->
</template>

<script>
//import someComponent from './someComponent'
export default {
  name: "",
  data() {
    return {

    }
  },
  component: {
    //someComponent
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
.policy-details{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin-top: 78px;
  background-color: #F5F7FA;
  .policy-title{
    width: 1200px;
    margin: 0 auto;
    ::v-deep .el-breadcrumb__inner.is-link{
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
    span{
      display: inline-block;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
  }
  .policy-content{
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 160px;
    .main-content{
      padding: 68px 48px;
      .title-content {
        width: 100%;
        border-bottom: 1px solid rgba(219, 221, 224, 0.5);
        padding-bottom: 20px;
        .details-title{
          width: 100%;
          h2{
            font-size: 30px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 45px;
          }
        }
      }
      .details-content {
        width: 100%;
        padding: 0;
        margin-top: 48px;
        p{
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #0A0D0F;
          line-height: 32px;
          letter-spacing: 1px;
          margin-bottom: 20px;
          text-align: justify;
        }
        strong{
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          color: #0A0D0F;
          line-height: 32px;
          letter-spacing: 1px;
          margin-bottom: 20px;
          display: inline-block;
          text-align: justify;
        }
        h3{
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 30px;
          margin-bottom: 20px;
          margin-top: 50px;
        }
        .con-part{
          margin-top: 50px;
          text-align: right;
          p{
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>